import { AlertConfig, LogConfig, LogModuleKey } from 'types/configuration'

export const configRootFields = {
  // ERP_MASTER: 'erpMaster',
  // ERP_INVENTORY: 'erpInventory',
  // ERP_PRICING: 'erpPricing',
  // ERP_ORDER_CREATE: 'erpOrderCreate',
  // ERP_RECONCILIATION: 'erpReconciliation',
  SAP_AUTH: 'sapAuth',
  SAP_ERP_ORDER: 'sapErpOrder',
  SAP_ERP_RMA: 'sapErpRma',
  SAP_ERP_RECONCILIATION: 'sapErpReconciliation',
  // BLOCK_SALE_POS: 'blockSaleOnPos',
  LAST_MILE: 'lastMile',
  SMTP: 'smtp',
  INVOICE: 'invoice',
  FRESH: 'freshSystem',
  SQL: 'sql',
  EXPRESSION: 'cronExpression',
  RMA_REASON: 'rmaReasons',
  RMA_CONDITIONS: 'rmaConditions',
  RMA_REASON_CODE_MAP: 'rmaReasonCodeMap',
  CLUSTERS: 'clusters',
  ORDER_TYPES: 'orderTypes',
  BAG: 'bags',
  SMS: 'sms',
  ALERT: 'alert',
  NOTIFICATION_CHANNELS: 'notificationChannels',
  PHARMACY: 'pharmacy',
  THIRD_PARTY_FTP: 'thirdPartyFtp',
}

export const ERP_FIELDS = {
  USERNAME: 'username',
  PASSWORD: 'password',
  URL: 'url',
  BEARER_TOKEN: 'bearerToken',
  IS_ENABLED: 'isEnabled',
}

export const talabatConfigurationFields = {
  IS_ACTIVE: {
    key: 'isActive',
    label: 'Is Talabat API Enable ?',
  },
  // Auth
  AUTH_URL: {
    key: 'authUrl',
    label: 'Auth URL',
  },
  WEBHOOK_AUTH_TOKEN: {
    key: 'webhookAuthToken',
    label: 'Webhook Auth Token',
  },
  ORDER_WEBHOOK_TOKEN: {
    key: 'orderWebhookToken',
    label: 'Order Webhook Token',
  },

  // API
  API_BASE_URL: {
    key: 'apiBaseUrl',
    label: 'API Base URL',
  },

  // Batch
  BATCH_SIZE: {
    key: 'batchSize',
    label: 'Batch Size',
  },
  ORDER_LOOKUP_WINDOW_MINUTES: {
    key: 'orderLookupWindowMinutes',
    label: 'Order Lookup Window (minutes)',
  },

  // Cron
  AGGREGATORS: {
    key: 'aggregators',
    label: 'Aggregators',
  },

  // Priority store sync
  PRIORITY_STORES: {
    key: 'priorityStores',
    label: 'Priority Stores',
  },
  PRIORITY_SYNC_BATCH_SIZE: {
    key: 'prioritySyncBatchSize',
    label: 'Priority Sync Batch Size',
  },
} as const

export const configurationsFields = {
  // Cron Expression
  EXPRESSION_MASTER: {
    parentKey: configRootFields.EXPRESSION,
    key: 'master',
    label: 'Master Data Cron Expression',
  },
  EXPRESSION_INVENTORY: {
    parentKey: configRootFields.EXPRESSION,
    key: 'inventory',
    label: 'Inventory Cron Expression',
  },
  EXPRESSION_TEMP_TO_MAIN_PRICING: {
    parentKey: configRootFields.EXPRESSION,
    key: 'pricingTempToMain',
    label: 'Temp to Main Pricing Cron Expression',
  },
  EXPRESSION_ORDER_SYNC: {
    parentKey: configRootFields.EXPRESSION,
    key: 'orderSync',
    label: 'Order Sync Cron Expression',
  },
  EXPRESSION_LASTMILE_SYNC: {
    parentKey: configRootFields.EXPRESSION,
    key: 'orderLastMileSync',
    label: 'Order Last Mile Sync Cron Expression',
  },
  EXPRESSION_RMA_SYNC: {
    parentKey: configRootFields.EXPRESSION,
    key: 'orderRmaSync',
    label: 'Order RMA Sync Cron Expression',
  },
  EXPRESSION_RECONCILIATION: {
    parentKey: configRootFields.EXPRESSION,
    key: 'reconciliation',
    label: 'Reconciliation Cron Expression',
  },

  EXPRESSION_WP_STORE_CODE_RESET: {
    parentKey: configRootFields.EXPRESSION,
    key: 'resetWpStoreCode',
    label: 'Reset Whatsapp Store Code Expression',
  },
  EXPRESSION_RESET_INVENTORY_QTY: {
    parentKey: configRootFields.EXPRESSION,
    key: 'resetErpQtyInventories',
    label: 'Reset Inventory ErpQty Cron Expression',
  },
  EXPRESSION_MONITOR_LAST_RUN_STATUS: {
    parentKey: configRootFields.EXPRESSION,
    key: 'monitorLastRunStatus',
    label: 'Monitor Last Run Status Cron Expression',
  },
  EXPRESSION_AGGREGATOR_API_LAST_RUN_MONITOR: {
    parentKey: configRootFields.EXPRESSION,
    key: 'aggregatorApiLastRunMonitor',
    label: 'Aggregator API Last Run Monitor Cron Expression',
  },
  EXPRESSION_MONITOR_UNSYNCED_ORDERS: {
    parentKey: configRootFields.EXPRESSION,
    key: 'monitorUnsyncedOrders',
    label: 'Orders Not Synced To SAP Monitor Cron Expression',
  },
  EXPRESSION_MONITOR_UNSYNCED_RECON: {
    parentKey: configRootFields.EXPRESSION,
    key: 'monitorUnsyncedRecon',
    label: 'Reconciliations Not Synced To SAP Monitor Cron Expression',
  },
  EXPRESSION_MONITOR_UNSYNCED_RMA: {
    parentKey: configRootFields.EXPRESSION,
    key: 'monitorUnsyncedRma',
    label: 'RMAs Not Synced To SAP Monitor Cron Expression',
  },
  EXPRESSION_MONITOR_SAP_INVENTORY_LAST_RUN: {
    parentKey: configRootFields.EXPRESSION,
    key: 'monitorSapInventoryLastRun',
    label: 'SAP Inventory Last Received Monitor Cron Expression',
  },
  EXPRESSION_MONITOR_FRESH_INVENTORY_LAST_RUN: {
    parentKey: configRootFields.EXPRESSION,
    key: 'monitorFreshInventoryLastRun',
    label: 'Fresh Inventory Last Run Monitor Cron Expression',
  },
  EXPRESSION_FRESH_MANDATORY_BARCODE_RESET: {
    parentKey: configRootFields.EXPRESSION,
    key: 'freshMandatoryBarcodeReset',
    label: 'Fresh Mandatory Barcode Reset Cron Expression',
  },

  EXPRESSION_EMP_ID: {
    parentKey: configRootFields.EXPRESSION,
    key: 'empIdSync',
    label: 'Employee Id Sync Cron Expression',
  },
  EXPRESSION_ERP_COST: {
    parentKey: configRootFields.EXPRESSION,
    key: 'costTracking',
    label: 'ERP Cost Cron Expression',
  },
  EXPRESSION_TALON_PAYLOAD: {
    parentKey: configRootFields.EXPRESSION,
    key: 'talonDataSync',
    label: 'Talon Payload Cron Expression',
  },
  EXPRESSION_ECOM_SPECIAL_PRICING: {
    parentKey: configRootFields.EXPRESSION,
    key: 'ecomExpiredSpecialPrice',
    label: 'Ecom Special Price Cron Expression',
  },
  EXPRESSION_AGGREGATOR_API: {
    parentKey: configRootFields.EXPRESSION,
    key: 'aggregatorApi',
    label: 'Aggregator API Cron Expression',
  },
  EXPRESSION_PRICING_ERP_TO_TEMP: {
    parentKey: configRootFields.EXPRESSION,
    key: 'pricingErpToTemp',
    label: 'ERP to Temp Pricing Cron Expression',
  },
  EXPRESSION_EXPIRE_SPECIAL_PRICING: {
    parentKey: configRootFields.EXPRESSION,
    key: 'expiredSpecialPrice',
    label: 'Expired Special Price Cron Expression',
  },
  EXPRESSION_MAGENTO_CATALOGUE_SYNC: {
    parentKey: configRootFields.EXPRESSION,
    key: 'magentoCatalogueSync',
    label: 'Magento Catalogue Sync Cron Expression',
  },
  EXPRESSION_CATALOGUE_AUTO_ENABLE: {
    parentKey: configRootFields.EXPRESSION,
    key: 'catalogueAutoEnable',
    label: 'Catalogue Auto Enable Cron Expression',
  },
  EXPRESSION_AGGREGATOR_API_FOR_SPECIFIC_AGGREGATOR_STORE: {
    parentKey: configRootFields.EXPRESSION,
    key: 'aggregatorApiStoreAggregator',
    label: 'Dark Store Aggregator API Cron Expression',
  },
  EXPRESSION_EXPIRED_OTP_CRON: {
    parentKey: configRootFields.EXPRESSION,
    key: 'expiredOTPCron',
    label: 'Expired OTP Cron Expression',
  },
  //foc

  // Pharmacy

  // Last Mile
  LAST_MILE_ORDER_CREATE: {
    parentKey: configRootFields.LAST_MILE,
    key: 'orderCreateUrl',
    label: 'Order Create',
  },

  LAST_MILE_ORDER_UPDATE: {
    parentKey: configRootFields.LAST_MILE,
    key: 'orderUpdateUrl',
    label: 'Order Update',
  },
  LAST_MILE_ORDER_CANCEL: {
    parentKey: configRootFields.LAST_MILE,
    key: 'orderCancelUrl',
    label: 'Order Cancel',
  },
  LAST_MILE_ORDER_UPDATE_CREATES: {
    parentKey: configRootFields.LAST_MILE,
    key: 'orderUpdateCratesUrl',
    label: 'Order Update Crates',
  },
  LAST_MILE_TOKEN: {
    parentKey: configRootFields.LAST_MILE,
    key: 'bearerToken',
    label: 'bearer Token',
  },

  // SQL
  SQL_USER_ERP_DB: {
    parentKey: configRootFields.SQL,
    key: 'useErpDb',
    label: 'ERP Source',
  },
  SQL_HOST: {
    parentKey: configRootFields.SQL,
    key: 'host',
    label: 'Host',
  },
  SQL_PORT: {
    parentKey: configRootFields.SQL,
    key: 'port',
    label: 'Port',
  },
  SQL_DATABASE_NAME: {
    parentKey: configRootFields.SQL,
    key: 'databaseName',
    label: 'Database Name',
  },
  SQL_USERNAME: {
    parentKey: configRootFields.SQL,
    key: 'username',
    label: 'Username',
  },
  SQL_PASSWORD: {
    parentKey: configRootFields.SQL,
    key: 'password',
    label: 'Password',
  },

  // SMTP
  SMTP_HOST: {
    parentKey: configRootFields.SMTP,
    key: 'host',
    label: 'Host',
  },
  SMTP_USERNAME: {
    parentKey: configRootFields.SMTP,
    key: 'username',
    label: 'Username',
  },
  SMTP_PASSWORD: {
    parentKey: configRootFields.SMTP,
    key: 'password',
    label: 'Password',
  },
  SMTP_FROM_NAME: {
    parentKey: configRootFields.SMTP,
    key: 'fromName',
    label: 'From Name',
  },
  SMTP_FROM_EMAIL: {
    parentKey: configRootFields.SMTP,
    key: 'fromEmail',
    label: 'From Email',
  },

  // Invoice
  INVOICE_PHONE: {
    parentKey: configRootFields.INVOICE,
    key: 'phone',
    label: 'Phone Number',
  },
  INVOICE_ADDRESS: {
    parentKey: configRootFields.INVOICE,
    key: 'bannerImg',
    label: 'Banner Image',
  },
  INVOICE_REG_NO: {
    parentKey: configRootFields.INVOICE,
    key: 'vatRegNo',
    label: 'VAT Registration Number',
  },

  // Purchase Timer Config (flat, top-level field)
  PURCHASE_TIMER_BUFFER: {
    key: 'purchaseTimerBufferMinutes',
    label: 'Buffer Time (minutes)',
  },

  // Special Price buffer (flat, top-level field)
  SPECIAL_PRICE_BUFFER: {
    key: 'specialPriceBufferMinutes',
    label: 'Special Price Buffer (minutes)',
  },
  // Other
  MAX_UPLOAD_SIZE: {
    key: 'maxUploadSize',
    label: 'Max Upload Size',
  },
  ADMIN_EMAIL: {
    key: 'adminEmail',
    label: 'Admin Email',
  },
  CS_NUMBER: {
    key: 'csNumber',
    label: 'CS Number',
  },
  FRESH_BARCODE_PREFIX: {
    key: 'freshBarcodePrefix',
    label: 'Fresh System Barcode Prefix',
  },
  MAX_ALLOWED_PRICE_DIFF_PERCENT: {
    key: 'maxAllowedPriceDiffPercent',
    label: 'Maximum Allowed Price Difference - Product level (%)',
  },
  MAX_ALLOWED_TOTAL_PRICE_DIFF_PERCENT: {
    key: 'maxAllowedTotalPriceDiffPercent',
    label: 'Maximum Allowed Total Price Difference (%)',
  },
  MAX_ALLOWED_PRICE_DIFF: {
    key: 'maxAllowedPriceDiff',
    label: 'Max Allow Price Difference - Product level',
  },
  LOG_DELETION_PERIOD: {
    key: 'logDeletionPeriod',
    label: 'Log Deletion Period',
  },
  MAX_CONCURRENT_AGGREGATORS: {
    key: 'maxConcurrentAggregators',
    label: 'Max Concurrent Aggregators',
  },
  DARK_STORES: {
    key: 'darkStores',
    label: 'Dark Stores',
  },
  BAG: {
    key: 'bags',
    label: 'Bags',
  },

  //sms configuration
  SMS_URL: {
    parentKey: configRootFields.SMS,
    key: 'url',
    label: 'URL',
  },
  SMS_USERNAME: {
    parentKey: configRootFields.SMS,
    key: 'userName',
    label: 'User Name',
  },
  SMS_SENDER_ID: {
    parentKey: configRootFields.SMS,
    key: 'senderId',
    label: 'Sender ID',
  },
  SMS_PASSWORD: {
    parentKey: configRootFields.SMS,
    key: 'password',
    label: 'Password',
  },
  SMS_MOBILE_NUMBERS: {
    parentKey: configRootFields.SMS,
    key: 'mobileNumbers',
    label: 'Mobile Numbers',
  },
  SMS_THROTTLE_MINUTES: {
    key: 'smsThrottleMinutes',
    label: 'ERP error SMS gap (minutes)',
  },
  SYNC_FAILURE_SMS_THROTTLE_MINUTES: {
    key: 'syncFailureSmsThrottleMinutes',
    label: 'SAP sync failure SMS gap (minutes)',
  },

  //alert configuration
  ALERT_IS_ENABLED: {
    parentKey: configRootFields.ALERT,
    key: 'isEnabled',
    label: 'Is Alert Enable ?',
  },
  ALERT_URL: {
    parentKey: configRootFields.ALERT,
    key: 'url',
    label: 'URL',
  },
  ALERT_BEARER_TOKEN: {
    parentKey: configRootFields.ALERT,
    key: 'bearerToken',
    label: 'Bearer Token',
  },
  AGGREGATOR_API_MAX_HOURS_WITHOUT_RUN: {
    key: 'aggregatorApiMaxHoursWithoutRun',
    label: 'Aggregator API no-run threshold (hours)',
  },
  SAP_CONNECTION_ALERT_THROTTLE_MINUTES: {
    key: 'sapConnectionAlertThrottleMinutes',
    label: 'SAP unreachable alert gap (minutes)',
  },
  SAP_ORDER_UNSYNCED_ALERT_HOURS: {
    key: 'sapOrderUnsyncedAlertHours',
    label: 'Order not-synced threshold (hours)',
  },
  SAP_RECON_UNSYNCED_ALERT_HOURS: {
    key: 'sapReconUnsyncedAlertHours',
    label: 'Reconciliation not-synced threshold (hours)',
  },
  SAP_RMA_UNSYNCED_ALERT_HOURS: {
    key: 'sapRmaUnsyncedAlertHours',
    label: 'RMA not-synced threshold (hours)',
  },
  SAP_INVENTORY_MAX_HOURS_WITHOUT_RUN: {
    key: 'sapInventoryMaxHoursWithoutRun',
    label: 'SAP inventory silence threshold (hours)',
  },
  SAP_INVENTORY_UPDATE_WINDOW_START: {
    key: 'sapInventoryUpdateWindowStart',
    label: 'Inventory Update Window Start',
  },
  SAP_INVENTORY_UPDATE_WINDOW_END: {
    key: 'sapInventoryUpdateWindowEnd',
    label: 'Inventory Update Window End',
  },
  FRESH_INVENTORY_MAX_HOURS_WITHOUT_RUN: {
    key: 'freshInventoryMaxHoursWithoutRun',
    label: 'Fresh inventory silence threshold (hours)',
  },
  INSTASHOP_LASTMILE_DELAY_ALERT_WINDOW: {
    key: 'instashopLastMileDelayAlertWindow',
    label: 'Lastmile delayed order threshold (minutes)',
  },
  NOTIFICATION_FALLBACK_THROTTLE_MINUTES: {
    key: 'notificationFallbackThrottleMinutes',
    label: 'Fallback notice gap (minutes)',
  },
  // Root-level, not under instashopLastmile: the window applies to every
  // lastmile the sync cron pushes to, Loginext included.
  LASTMILE_MAX_ORDER_AGE_HOURS: {
    key: 'lastMileMaxOrderAgeHours',
    label: 'Order Age Window (hours)',
  },

  // Third Party FTP
  THIRD_PARTY_FTP_PROTOCOL: {
    parentKey: configRootFields.THIRD_PARTY_FTP,
    key: 'protocol',
    label: 'Protocol',
  },
  THIRD_PARTY_FTP_HOST: {
    parentKey: configRootFields.THIRD_PARTY_FTP,
    key: 'host',
    label: 'Host',
  },
  THIRD_PARTY_FTP_PORT: {
    parentKey: configRootFields.THIRD_PARTY_FTP,
    key: 'port',
    label: 'Port',
  },
  THIRD_PARTY_FTP_USERNAME: {
    parentKey: configRootFields.THIRD_PARTY_FTP,
    key: 'username',
    label: 'Username',
  },
  THIRD_PARTY_FTP_PASSWORD: {
    parentKey: configRootFields.THIRD_PARTY_FTP,
    key: 'password',
    label: 'Password',
  },

  // Pharmacy
  PHARMACY_ENABLE_3PL_IMPORT: {
    parentKey: configRootFields.PHARMACY,
    key: 'enable3PLProductImport',
    label: 'Enable 3PL Product Import',
  },
} as const

export const powerBiConfigFields = {
  ORDER_URL: {
    key: 'orderUrl',
    label: 'Order URL',
  },
  TOKEN: {
    key: 'token',
    label: 'Bearer Token',
  },
  IS_ENABLED: {
    key: 'isEnabled',
    label: 'Enable Power BI Sync',
  },
} as const

export const notificationChannelFields = [
  {
    key: 'alert',
    label: 'Alert Service',
    hintText: 'Post failures to the alert service above.',
  },
  {
    key: 'email',
    label: 'Email',
    hintText: 'Email failures to the admin email.',
  },
  {
    key: 'sms',
    label: 'SMS',
    hintText:
      'Send failures by SMS to the configured numbers. Each failure type still decides whether it uses SMS.',
  },
  {
    key: 'fallback',
    label: 'Fallback On Channel Failure',
    hintText:
      'If one channel fails to send, notify the other enabled channels (SMS included) so the broken channel is noticed.',
  },
] as const

export const magentoConfigFields = {
  STORE: {
    key: 'store',
    label: 'Store',
  },
  AGGREGATOR: {
    key: 'aggregator',
    label: 'Aggregator',
  },
  MAGENTO_BASE_URL: {
    key: 'magentoBaseUrl',
    label: 'Magento Base URL',
  },
  MAGENTO_TOKEN: {
    key: 'magentoToken',
    label: 'Magento Token',
  },
  INVENTORY_LIMIT: {
    key: 'inventoryLimit',
    label: 'Inventory Limit',
  },
  PRICING_LIMIT: {
    key: 'pricingLimit',
    label: 'Pricing Limit',
  },
  CATALOGUE_LIMIT: {
    key: 'catalogueLimit',
    label: 'Catalogue Limit',
  },
  PURCHASE_TIMER_LIMIT: {
    key: 'purchaseTimerLimit',
    label: 'Purchase Timer Limit',
  },
  IS_INVENTORY_SYNC_ENABLED: {
    key: 'isInventorySyncEnabled',
    label: 'Enable Inventory Sync',
  },
  INVENTORY_SYNC_CHUNK_SIZE: {
    key: 'inventorySyncChunkSize',
    label: 'Inventory Sync Chunk Size',
  },
  SYNC_BUNDLE_PRODUCT: {
    key: 'syncBundleProduct',
    label: 'Enable Bundle Product Sync',
  },
} as const

export const kdsConfigFields = {
  CREATE_ORDER_URL: {
    key: 'createOrderUrl',
    label: 'Create/Update Order URL',
  },
  CANCEL_ORDER_URL: {
    key: 'cancelOrderUrl',
    label: 'Cancel Order URL',
  },
  USERNAME: {
    key: 'username',
    label: 'Username',
  },
  PASSWORD: {
    key: 'password',
    label: 'Password',
  },
  WEBHOOK_SECRET: {
    key: 'webhookSecret',
    label: 'Webhook Secret',
  },
  SLA_MINUTES: {
    key: 'slaMinutes',
    label: 'SLA (Minutes)',
  },
  IS_ENABLED: {
    key: 'isEnabled',
    label: 'Enable KDS Sync',
  },
} as const

export const instashopLastmileConfigFields = {
  IS_ENABLED: {
    key: 'isEnabled',
    label: 'Enable Instashop Lastmile Integration',
  },
  SECRET_KEY: {
    key: 'secretKey',
    label: 'Secret Key',
  },
  API_KEY: {
    key: 'apiKey',
    label: 'API Key',
  },
  BASE_URL: {
    key: 'baseUrl',
    label: 'Base URL',
  },
  AGG_INT_WEBHOOK_URL: {
    key: 'aggIntWebhookUrl',
    label: 'AGG INT Webhook URL',
  },
  AGG_INT_BEARER_TOKEN: {
    key: 'aggIntBearerToken',
    label: 'AGG INT Bearer Token',
  },
  GOOGLE_MAP_API_KEY: {
    key: 'googleMapApiKey',
    label: 'Google Map API Key',
  },
  RECONCILIATION_EXPORT_IS_ENABLED: {
    key: 'reconciliationExportIsEnabled',
    label: 'Enable Reconciliation Export',
  },
  RECONCILIATION_EXPORT_CRON_EXPRESSION: {
    key: 'reconciliationExportCronExpression',
    label: 'Reconciliation Export Cron Expression',
  },
  SFTP_PROTOCOL: {
    parentKey: 'sftp',
    key: 'protocol',
    label: 'Protocol',
  },
  SFTP_HOST: {
    parentKey: 'sftp',
    key: 'host',
    label: 'Host',
  },
  SFTP_PORT: {
    parentKey: 'sftp',
    key: 'port',
    label: 'Port',
  },
  SFTP_USERNAME: {
    parentKey: 'sftp',
    key: 'username',
    label: 'Username',
  },
  SFTP_PASSWORD: {
    parentKey: 'sftp',
    key: 'password',
    label: 'Password',
  },
  SFTP_DIRECTORY: {
    parentKey: 'sftp',
    key: 'directory',
    label: 'Directory',
  },
} as const

export type ManualCronFields = {
  lastUpdatedDateTime: string
}

export const expressionKeys = [
  configurationsFields.EXPRESSION_MASTER,
  configurationsFields.EXPRESSION_INVENTORY,
  configurationsFields.EXPRESSION_TEMP_TO_MAIN_PRICING,
  configurationsFields.EXPRESSION_ORDER_SYNC,
  configurationsFields.EXPRESSION_RECONCILIATION,
  configurationsFields.EXPRESSION_LASTMILE_SYNC,
  configurationsFields.EXPRESSION_RMA_SYNC,
  configurationsFields.EXPRESSION_EMP_ID,
  configurationsFields.EXPRESSION_ERP_COST,
  configurationsFields.EXPRESSION_TALON_PAYLOAD,
  configurationsFields.EXPRESSION_ECOM_SPECIAL_PRICING,
  configurationsFields.EXPRESSION_AGGREGATOR_API,
  configurationsFields.EXPRESSION_PRICING_ERP_TO_TEMP,
  configurationsFields.EXPRESSION_EXPIRE_SPECIAL_PRICING,
  configurationsFields.EXPRESSION_MAGENTO_CATALOGUE_SYNC,
  configurationsFields.EXPRESSION_AGGREGATOR_API_LAST_RUN_MONITOR,
  configurationsFields.EXPRESSION_FRESH_MANDATORY_BARCODE_RESET,
  // DELIVEROO_FIELDS.EXPR_LISTING,

  // talabatConfigurationFields.EXPR_ADD_PRODUCT_CRON,
  instashopLastmileConfigFields.RECONCILIATION_EXPORT_CRON_EXPRESSION,
]

export const expressionType: Record<string, string> = Object.fromEntries(
  expressionKeys.map((field) => [field.key, field.label]),
)

const ALERT_TEXT_KEYS = [
  configurationsFields.ALERT_URL.key,
  configurationsFields.ALERT_BEARER_TOKEN.key,
] as const

/**
 * Build the `alert` block for the config PATCH.
 *
 * The backend reads both strings as "optional, but not blank": omitting a key
 * leaves the stored value untouched, sending `''` is a 422 (`IS_EMPTY`). The
 * Alert Config form submits every input on every save, so a token the user
 * never retyped would otherwise go out empty and fail the whole request — drop
 * the blanks instead. `isEnabled` is always sent: it is a real boolean and must
 * be able to reach `false`.
 *
 * Only the keys listed here are ever sent, so the retired `userName`/`password`
 * pair from the Basic-auth era is never written back to a config that still
 * carries it.
 */
export const buildAlertPayload = (
  alert?: Partial<AlertConfig>,
): Partial<AlertConfig> =>
  ALERT_TEXT_KEYS.reduce<Partial<AlertConfig>>(
    (acc, key) => {
      const value = alert?.[key]?.trim()
      if (value) acc[key] = value
      return acc
    },
    { isEnabled: Boolean(alert?.isEnabled) },
  )

/**
 * Alert timing settings that are optional on the backend but must be numeric
 * when present. Listed once so the submit handler can strip the blank ones
 * without a hand-written branch per field.
 */
export const ALERT_NUMERIC_FIELD_KEYS = [
  configurationsFields.AGGREGATOR_API_MAX_HOURS_WITHOUT_RUN.key,
  configurationsFields.SAP_CONNECTION_ALERT_THROTTLE_MINUTES.key,
  configurationsFields.SAP_ORDER_UNSYNCED_ALERT_HOURS.key,
  configurationsFields.SAP_RECON_UNSYNCED_ALERT_HOURS.key,
  configurationsFields.SAP_RMA_UNSYNCED_ALERT_HOURS.key,
  configurationsFields.SAP_INVENTORY_MAX_HOURS_WITHOUT_RUN.key,
  configurationsFields.FRESH_INVENTORY_MAX_HOURS_WITHOUT_RUN.key,
  configurationsFields.INSTASHOP_LASTMILE_DELAY_ALERT_WINDOW.key,
  configurationsFields.NOTIFICATION_FALLBACK_THROTTLE_MINUTES.key,
] as const

/**
 * Drops the listed keys when the user left them blank.
 *
 * An untouched box arrives as `''`, which the backend rejects, whereas an absent
 * key leaves the stored value alone — so "blank" has to mean "don't send".
 */
export const omitBlankKeys = <T extends Record<string, any>>(
  source: T,
  keys: readonly string[],
): T => {
  const result = { ...source }

  keys.forEach((key) => {
    if (!String(result[key] ?? '').trim()) delete result[key]
  })

  return result
}

/**
 * Returns only the listed keys the user actually filled in, coerced to numbers,
 * ready to spread over the payload.
 */
export const pickFilledNumbers = (
  source: Record<string, any>,
  keys: readonly string[],
): Record<string, number> =>
  keys.reduce<Record<string, number>>((acc, key) => {
    const value = String(source?.[key] ?? '').trim()
    if (value) acc[key] = Number(value)
    return acc
  }, {})

// Toggleable log modules (S3 log-file upload). Order follows the product spec's
// suggested label list. POS/KDS/PowerBi/AdminAudit are intentionally excluded —
// they keep their detail in the DB row, so there is no S3 file to switch off.
// FTP Creation and Export were removed: their S3 file is the feature's
// deliverable, not a log, and the backend now 422s on those two keys.
// This list is the single source of truth for the payload — the backend rejects
// any key outside it, including `ftpCreation`/`export` left over on old records.
export const LOG_MODULES: { key: LogModuleKey; label: string }[] = [
  { key: 'order', label: 'Order Logs' },
  { key: 'reconciliation', label: 'Reconciliation Logs' },
  { key: 'erp', label: 'ERP Logs' },
  { key: 'aggregatorApi', label: 'Aggregator API Logs' },
  { key: 'import', label: 'Import Logs' },
  { key: 'talabatApi', label: 'Talabat Sync Logs' },
  { key: 'deliverooSync', label: 'Deliveroo Sync Logs' },
  { key: 'catalogueAction', label: 'Catalogue Action Logs' },
  { key: 'magentoCatalogue', label: 'Magento Catalogue Sync Logs' },
  { key: 'talon', label: 'Talon Logs' },
  { key: 'lastMile', label: 'Last Mile Logs' },
]

// Normalise a (possibly partial/absent) logConfig into a full 10-key object,
// dropping any stale key the API still returns. Any missing/undefined key
// defaults to `true` (enabled) — same rule the backend applies to an unset
// flag. Values are always real booleans; the backend 422s on `"false"`.
export const buildLogConfig = (
  logConfig?: LogConfig,
): Record<LogModuleKey, boolean> =>
  LOG_MODULES.reduce(
    (acc, { key }) => {
      acc[key] = logConfig?.[key] ?? true
      return acc
    },
    {} as Record<LogModuleKey, boolean>,
  )
